import styled from "@emotion/styled";

import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";

import IconNewsletter from "./newsletter.svg";

export const Container = styled.div<ResponsiveStyledProps>`
  inline-size: 24px;
  block-size: 24px;

  ${responsiveStyles}
`;

export const StyledIconNewsletter = styled(IconNewsletter)`
  inline-size: 100%;
  block-size: 100%;
`;
